export default "__VITE_ASSET__BIOpqral__"